import { Component } from '@angular/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent { public user = { email: '',
password: ''
};
  title = 'app';
}




// WEBPACK FOOTER //
// ./src/app/app.component.ts